<template>
    <div class="topicList">
        <Header title="话题" v-if="!isWx" />
        <div class="content">
            <van-list
                v-model="loading"
                :finished="finished"
                finished-text="没有更多了"
                @load="initTopicList"
            >
                <van-cell v-for="item in topicList" :key="item.id">
                    <div class="item" @click="jumpDetails(item.id)">
                        <div>
                            <van-image
                                lazy-load
                                fit="cover"
                                width="100%"
                                height="188"
                                :src="item.image"
                            />
                            <div class="prople">
                                <p>#&nbsp;&nbsp;{{ item.title }}</p>
                                <span>{{ item.join_num }}人参与</span>
                            </div>
                        </div>
                        <p>{{ item.describe }}</p>
                    </div>
                </van-cell>
            </van-list>
        </div>
    </div>
</template>
<script>
import { Header } from "@/components";
import { getShowImageTopicList } from "@/request/api";
import { checkWx, navigate } from '@/pages/index/custom'

export default {
    components: {
        Header
    },
    data() {
        return {
            topicList: [], // 话题列表
            loading: false, // 加载中
            finished: false, // 加载完毕
            reportPage: 1, // 页数
            isWx: true
        };
    },
    methods: {
        // 初始化话题列表
        initTopicList() {
            getShowImageTopicList({
                page: this.reportPage,
                pcount: 10
            })
                .then(res => {
                    let { data, error_code } = res;
                    if (error_code === 0) {
                        if (data.length === 0 || !data) {
                            this.finished = true;
                            return false;
                        }
                        data.map(item => this.topicList.push(item));
                        this.reportPage++;
                        this.loading = false;
                    }
                })
                .catch(error => {
                    console.log(error);
                });
        },
        // 详情页跳转
        jumpDetails(id) {
            navigate({ path: "topicDetails", query: { id: id } });
        }
    },
    created() {
        this.isWx = checkWx()
    }
};
</script>

<style lang="less" scoped>
.content {
    background-color: #f8f8f8;
    box-sizing: border-box;
    padding: 72px 20px 60px 20px;
}
.item {
    border-radius: 6px;
    background-color: #fff;
    overflow: hidden;
    & > div {
        position: relative;
    }
    .prople {
        position: absolute;
        left: 0.75rem;
        bottom: 0.75rem;
        p {
            font-size: 16px;
            font-weight: 500;
            color: rgba(255, 255, 255, 1);
        }
        span {
            font-size: 12px;
            font-weight: 400;
            color: rgba(255, 255, 255, 1);
        }
    }
    & > p {
        font-size: 16px;
        font-weight: 400;
        color: rgba(34, 34, 34, 1);
        line-height: 22px;
        box-sizing: border-box;
        padding: 0.5rem 0.75rem 1rem 0.75rem;
    }
}
</style>
